// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ApplicationController from "./application_controller.js";
application.register("application", ApplicationController);

import AsideSectionController from "./aside_section_controller.js";
application.register("aside-section", AsideSectionController);

import AssignmentController from "./assignment_controller.js";
application.register("assignment", AssignmentController);

import BlogChartController from "./blog_chart_controller.js";
application.register("blog-chart", BlogChartController);
import ChannelsChartController from "./channels_chart_controller.js";
application.register("channels-chart", ChannelsChartController);

import ChartsController from "./charts_controller.js";
application.register("charts", ChartsController);

import ChecklistItemController from "./checklist_item_controller.js";
application.register("checklist-item", ChecklistItemController);

import CheckboxRevealController from "./checkbox_reveal_controller.js";
application.register("checkbox-reveal", CheckboxRevealController);
import AffiliateReviewController from "./affiliate_review_controller.js";
application.register("affiliate-review", AffiliateReviewController);

import ClearbitController from "./clearbit_controller.js";
application.register("clearbit", ClearbitController);

import CommentsController from "./comments_controller.js";
application.register("comments", CommentsController);

import FlashesController from "./flashes_controller.js";
application.register("flashes", FlashesController);

import IntercomUnreadController from "./intercom_unread_controller.js";
application.register("intercom-unread", IntercomUnreadController);

import KitPresenceController from "./kit_presence_controller.js";
application.register("kit-presence", KitPresenceController);

import KitSeenController from "./kit_seen_controller.js";
application.register("kit-seen", KitSeenController);

import KitTranscriptController from "./kit_transcript_controller.js";
application.register("kit-transcript", KitTranscriptController);

import LinkReportController from "./link_report_controller.js";
application.register("link-report", LinkReportController);

import MediaKitController from "./media_kit_controller.js";
application.register("media-kit", MediaKitController);

import ModalController from "./modal_controller.js";
application.register("modal", ModalController);

import NestedFormController from "./nested_form_controller.js";
application.register("nested-form", NestedFormController);

import ReactionsController from "./reactions_controller.js";
application.register("reactions", ReactionsController);

import ResetFormController from "./reset_form_controller.js";
application.register("reset-form", ResetFormController);

import SignupController from "./signup_controller.js";
application.register("signup", SignupController);

import SortableController from "./sortable_controller.js";
application.register("sortable", SortableController);

import SurveyQuestionController from "./survey_question_controller.js";
application.register("survey-question", SurveyQuestionController);

import Autosave from "stimulus-rails-autosave";
application.register("autosave", Autosave);

import ClickableRowController from "./clickable_row_controller.js";
application.register("clickable-row", ClickableRowController);

import ChangelogController from "./changelog_controller.js";
application.register("changelog", ChangelogController);

import DismissableController from "./dismissable_controller.js";
application.register("dismissable", DismissableController);

import McpSetupController from "./mcp_setup_controller.js";
application.register("mcp-setup", McpSetupController);

import AutoplayVideoController from "./autoplay_video_controller.js";
application.register("autoplay-video", AutoplayVideoController);

import ChatInputController from "./chat_input_controller.js";
application.register("chat-input", ChatInputController);

import ChatScrollController from "./chat_scroll_controller.js";
application.register("chat-scroll", ChatScrollController);

import ChatSuggestionsController from "./chat_suggestions_controller.js";
application.register("chat-suggestions", ChatSuggestionsController);

import ClipboardCopyController from "./clipboard_copy_controller.js";
application.register("clipboard-copy", ClipboardCopyController);

import ReferralKitGeneratorController from "./referral_kit_generator_controller.js";
application.register("referral-kit-generator", ReferralKitGeneratorController);

import PitchEditorController from "./pitch_editor_controller.js";
application.register("pitch-editor", PitchEditorController);

import DeliverableChatController from "./deliverable_chat_controller.js";
application.register("deliverable-chat", DeliverableChatController);

import SuggestionTimeoutController from "./suggestion_timeout_controller.js";
application.register("suggestion-timeout", SuggestionTimeoutController);

import BulkTagController from "./bulk_tag_controller.js";
application.register("bulk-tag", BulkTagController);

import ListBulkController from "./list_bulk_controller.js";
application.register("list-bulk", ListBulkController);

import ListAddCreatorController from "./list_add_creator_controller.js";
application.register("list-add-creator", ListAddCreatorController);

import CreatorSaveListController from "./creator_save_list_controller.js";
application.register("creator-save-list", CreatorSaveListController);

import IconPickerController from "./icon_picker_controller.js";
application.register("icon-picker", IconPickerController);

import CreatorListFormController from "./creator_list_form_controller.js";
application.register("creator-list-form", CreatorListFormController);

import ListModalController from "./list_modal_controller.js";
application.register("list-modal", ListModalController);

import ListModalOpenerController from "./list_modal_opener_controller.js";
application.register("list-modal-opener", ListModalOpenerController);

import SavedInfluencerTagsController from "./saved_influencer_tags_controller.js";
application.register("saved-influencer-tags", SavedInfluencerTagsController);

import SavedSearchQueryController from "./saved_search_query_controller.js";
application.register("saved-search-query", SavedSearchQueryController);

import DiscoveryFiltersController from "./discovery_filters_controller.js";
application.register("discovery-filters", DiscoveryFiltersController);

import DiscoverySearchController from "./discovery_search_controller.js";
application.register("discovery-search", DiscoverySearchController);

import RecommendationsController from "./recommendations_controller.js";
application.register("recommendations", RecommendationsController);

import KitPanelController from "./kit_panel_controller.js";
application.register("kit-panel", KitPanelController);

import KitMenuController from "./kit_menu_controller.js";
application.register("kit-menu", KitMenuController);

import KitTabRenameController from "./kit_tab_rename_controller.js";
application.register("kit-tab-rename", KitTabRenameController);

import KitTabsController from "./kit_tabs_controller.js";
application.register("kit-tabs", KitTabsController);

import MessageFeedbackController from "./message_feedback_controller.js";
application.register("message-feedback", MessageFeedbackController);

import KitChoicesController from "./kit_choices_controller.js";
application.register("kit-choices", KitChoicesController);

import KitQuestionFormController from "./kit_question_form_controller.js";
application.register("kit-question-form", KitQuestionFormController);

import KitChartController from "./kit_chart_controller.js";
application.register("kit-chart", KitChartController);

import ImageFallbackController from "./image_fallback_controller.js";
application.register("image-fallback", ImageFallbackController);

import ScreenshotCaptureController from "./screenshot_capture_controller.js";
application.register("screenshot-capture", ScreenshotCaptureController);

import InsightsCardController from "./insights_card_controller.js";
application.register("insights-card", InsightsCardController);

import ChatActionController from "./chat_action_controller.js";
application.register("chat-action", ChatActionController);

import TadaOnHoverController from "./tada_on_hover_controller.js";
application.register("tada-on-hover", TadaOnHoverController);

import FeatureDiscoveryController from "./feature_discovery_controller.js";
application.register("feature-discovery", FeatureDiscoveryController);

import TeamInviteController from "./team_invite_controller.js";
application.register("team-invite", TeamInviteController);

import RecommendationsPollingController from "./recommendations_polling_controller.js";
application.register(
  "recommendations-polling",
  RecommendationsPollingController
);

import OnboardingFeatureCardController from "./onboarding_feature_card_controller.js";
application.register(
  "onboarding-feature-card",
  OnboardingFeatureCardController
);

import OnboardingStepController from "./onboarding_step_controller.js";
application.register("onboarding-step", OnboardingStepController);

import PaginationFeedbackController from "./pagination_feedback_controller.js";
application.register("pagination-feedback", PaginationFeedbackController);

import PdfGateController from "./pdf_gate_controller.js";
application.register("pdf-gate", PdfGateController);

import FlexInterstitialController from "./flex_interstitial_controller.js";
application.register("flex-interstitial", FlexInterstitialController);

import DemoCountdownController from "./demo_countdown_controller.js";
application.register("demo-countdown", DemoCountdownController);

import NewPitchController from "./new_pitch_controller.js";
application.register("new-pitch", NewPitchController);

// Hotwire Native bridge components (no-ops on the web; active inside the apps).
import BridgeConnectController from "./bridge/connect_controller.js";
application.register("bridge--connect", BridgeConnectController);

import BridgeButtonController from "./bridge/button_controller.js";
application.register("bridge--button", BridgeButtonController);

import BridgeMenuController from "./bridge/menu_controller.js";
application.register("bridge--menu", BridgeMenuController);

import BridgeSessionController from "./bridge/session_controller.js";
application.register("bridge--session", BridgeSessionController);

import BridgePushController from "./bridge/push_controller.js";
application.register("bridge--push", BridgePushController);

// Plain Stimulus (not a bridge component) — on the Hotwire Native OAuth-return
// page, redirects to the influencekit:// scheme from inside the external auth
// browser. See oauth_return_controller.js.
import OauthReturnController from "./oauth_return_controller.js";
application.register("oauth-return", OauthReturnController);

import PhoneLoginController from "./phone_login_controller.js";
application.register("phone-login", PhoneLoginController);

import PasswordVisibilityController from "./password_visibility_controller.js";
application.register("password-visibility", PasswordVisibilityController);

// Tap-to-open for the CSS-only `.ui.simple.dropdown` ⋮ menus. Mounted once on
// <body> (layouts/application.html.haml); delegates to the whole document. See
// simple_dropdown_touch_controller.js and _touch_dropdowns.scss.
import SimpleDropdownTouchController from "./simple_dropdown_touch_controller.js";
application.register("simple-dropdown-touch", SimpleDropdownTouchController);

import PaymentReasonController from "./payment_reason_controller.js";
application.register("payment-reason", PaymentReasonController);

import PaymentTargetController from "./payment_target_controller.js";
application.register("payment-target", PaymentTargetController);

import BulkApproveController from "./bulk_approve_controller.js";
application.register("bulk-approve", BulkApproveController);

import BulkPayController from "./bulk_pay_controller.js";
application.register("bulk-pay", BulkPayController);

import PollController from "./poll_controller.js";
application.register("poll", PollController);

import ReviewActionsController from "./review_actions_controller.js";
application.register("review-actions", ReviewActionsController);

import SubmitOnceController from "./submit_once_controller.js";
application.register("submit-once", SubmitOnceController);

import InviteFormController from "./invite_form_controller.js";
application.register("invite-form", InviteFormController);

import ListRailController from "./list_rail_controller.js";
application.register("list-rail", ListRailController);

import AutoSubmitController from "./auto_submit_controller.js";
application.register("auto-submit", AutoSubmitController);

import RosterController from "./roster_controller.js";
application.register("roster", RosterController);

import ReferralTrackController from "./referral_track_controller.js";
application.register("referral-track", ReferralTrackController);

import ReferralPayoutCtaController from "./referral_payout_cta_controller.js";
application.register("referral-payout-cta", ReferralPayoutCtaController);

// Enter on a highlighted/focused `<a class="item">` in a Fomantic dropdown
// menu. Scoped per-element, not document-wide — see the file for why.
import DropdownLinkKeysController from "./dropdown_link_keys_controller.js";
application.register("dropdown-link-keys", DropdownLinkKeysController);

import SearchClearController from "./search_clear_controller.js";
application.register("search-clear", SearchClearController);

import QuotaOverrideController from "./quota_override_controller.js";
application.register("quota-override", QuotaOverrideController);

import EarningsChartController from "./earnings_chart_controller.js";
application.register("earnings-chart", EarningsChartController);

import CreatorRailController from "./creator_rail_controller.js";
application.register("creator-rail", CreatorRailController);
